import React from 'react';
import { Badge } from '@edgebox/react-components';
import { EntityRemoteStatus } from '@edgebox/sync-core-data-definitions';

export function RemoteEntityStatusBadge({ status }: { status: EntityRemoteStatus }): React.ReactElement {
  const isDeleted = status === EntityRemoteStatus.LocalDeletion;
  const variant = status === EntityRemoteStatus.Exists ? 'success' : isDeleted ? 'warning' : 'secondary';

  return <Badge bg={variant}>{isDeleted ? 'Deleted' : status}</Badge>;
}
